var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bank-verification-step" }, [
    _c("div", { staticClass: "bv-header" }, [
      _c("div", { staticClass: "bv-header__icon" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M3 9L12 3L21 9V21H15V15H9V21H3V9Z",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bv-trust-bar" }, [
      _c("div", { staticClass: "bv-trust-item" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 16 16",
              fill: "currentColor",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("Read-only access")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bv-trust-item" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 16 16",
              fill: "currentColor",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("Bank-grade encryption")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bv-trust-item" }, [
        _c(
          "svg",
          {
            attrs: {
              viewBox: "0 0 16 16",
              fill: "currentColor",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("No login credentials stored")]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bv-iframe-wrap" }, [
      _c(
        "iframe",
        {
          ref: "csIframe",
          staticClass: "bv-iframe",
          attrs: { id: "creditSenseIFrame", src: "about:blank" },
        },
        [_vm._v("\n      iframes are not supported in this browser\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bv-header__text" }, [
      _c("h3", { staticClass: "bv-header__title" }, [
        _vm._v("Connect your bank account"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "bv-header__sub" }, [
        _vm._v(
          "We securely connect to your bank to verify income and expenses. This helps us assess your application faster and more accurately."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }